import * as React from 'react';
import * as ReactDOM from 'react-dom';

const modalRoot: HTMLElement | null = document.getElementById('modal-root');

export class ModalPortal extends React.Component<{}> {
  private el: HTMLDivElement | null = document.createElement('div');

  public componentDidMount() {
    if (modalRoot && this.el) {
      modalRoot.appendChild(this.el);
    }
  }

  public componentWillUnmount() {
    if (modalRoot && this.el) {
      modalRoot.removeChild(this.el);
    }
  }

  public render() {
    if (this.props.children) {
      return ReactDOM.createPortal(this.props.children, this.el!);
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Modals/ModalPortal.tsx